import {AbstractModel} from './abstract-model';
import {GoalType} from './goal-type';

export class OfferGoalType extends AbstractModel {
  id: number | null = null;
  goalType: GoalType | null = null;
  payoutAmount: number | null = null;
  payoutPercent: number | null = null;

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.goalType) {
      this.goalType = new GoalType().deserialize(input.goalType);
    }

    return this;
  }
}
